var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"main-layout",attrs:{"max-width":"100%"}},[_c('NotifySection'),_c('NewsSection'),_c('ShortcutSection'),_c('WorkerCreditHubDashboard'),_c('SimplifiedProposalTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }